import React, { useMemo } from "react"
import { useTranslation } from "react-i18next"
import { CustomProvider } from "rsuite"
import "rsuite/dist/rsuite.min.css"
import { getRsuiteBaseLocale } from "utils/datePickerLocale"

/**
 * Applies RSuite calendar/datepicker locale (and shared button labels)
 * for the whole portal based on the active i18n language.
 */
const RsuiteLocaleProvider = ({ children }) => {
  const {
    t,
    i18n: { language },
  } = useTranslation()

  const locale = useMemo(() => {
    const baseLocale = getRsuiteBaseLocale(language)
    return {
      ...baseLocale,
      DatePicker: {
        ...baseLocale.DatePicker,
        ok: t("OK"),
        clean: t("Clear"),
        today: t("Today"),
      },
      DateRangePicker: {
        ...baseLocale.DateRangePicker,
        ok: t("OK"),
        clean: t("Clear"),
      },
      Calendar: {
        ...baseLocale.Calendar,
      },
    }
  }, [language, t])

  return <CustomProvider locale={locale}>{children}</CustomProvider>
}

export default RsuiteLocaleProvider
